import classNames from 'classnames';

import Link from '~/shared/components/link';

import '~/shared/components/bread-crumbs/bread-crumbs.scss';

type BreadCrumbsPropsType = {
  links: {
    name: string;
    href: string;
  }[];
  t: (key: string, options: { ns: string[] }) => string;
};

const BreadCrumbs = ({ links, t, className }: BreadCrumbsPropsType) => (
  <ul itemScope itemType="http://schema.org/BreadcrumbList" className={classNames('bread-crumbs', className)}>
    {links?.map((link, i) => {
      return (
        <li key={i} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <Link itemProp="item" href={link.href}>
            <span itemProp="name">{link.name}</span>
          </Link>
          <meta itemProp="position" content={`${i + 1}`} />
        </li>
      );
    })}
  </ul>
);

export default BreadCrumbs;
